import {GridColDef} from '@mui/x-data-grid';
import {get} from 'lodash';
import {DateHelpers} from '../../../shared/helpers/dateHelpers';
import Status from '../../../ui/status/Status';
import {BASE_TITLES} from '../../../shared/constants';
import {ServiceRequestShortDto} from '../../../global/api';
import {TypeServiceRequestStatusCode} from '../../../shared/types/serviceRequest.types';

export function getColumns(): GridColDef<ServiceRequestShortDto>[] {
  return [
    {
      field: 'id',
      headerName: BASE_TITLES.id.base,
      minWidth: 60,
    },
    {
      field: 'companyId',
      headerName: BASE_TITLES.company.base,
      flex: 1,
      renderCell: ({row}) => row?.companyName || '-',
    },
    {
      field: 'contract',
      headerName: BASE_TITLES.contract.base,
      renderCell: ({row}) => row?.contractNumber || '-',
    },
    {
      field: 'customer',
      headerName: BASE_TITLES.customer.base,
      renderCell: ({row}) => row.customer || '-',
    },
    {
      field: 'manager',
      headerName: BASE_TITLES.manager.base,
      renderCell: ({row}) => row.manager || '-',
    },
    {
      field: 'workers',
      headerName: BASE_TITLES.workers.base,
      renderCell: ({row}) => row.workers || '-',
    },
    {
      field: 'address',
      headerName: BASE_TITLES.address.base,
      renderCell: ({row}) => row.fullAddress || '-',
    },
    {
      field: 'taskLocation',
      headerName: BASE_TITLES.taskLocation.base,
      renderCell: ({row}) => row.workLocation || '-',
    },
    {
      field: 'deviceType',
      headerName: BASE_TITLES.deviceType.base,
      renderCell: ({row}) => row.serviceType,
    },
    {
      field: 'createdDate',
      headerName: BASE_TITLES.createdDate.base,
      renderCell: ({row}) => DateHelpers.formatToRu(row.createdDate),
    },
    {
      field: 'executedDate',
      headerName: BASE_TITLES.executedDate.base,
      renderCell: ({row}) => DateHelpers.formatToRu(row.executedDate),
    },
    {
      field: 'status',
      headerName: BASE_TITLES.status.base,
      minWidth: 172,
      renderCell: ({row}) => {
        const archived = get(row, 'archived', false);

        return (
          <Status
            border={row.statusCode === 'CREATED' || archived}
            sx={{fontSize: '12px'}}
            variant="subtitle2"
            entity="serviceRequest"
            code={archived ? 'ARCHIVED' : (row.statusCode as TypeServiceRequestStatusCode)}
          />
        );
      },
    },
  ];
}
